import PAGE_CODES from "themes/register/PageCodes";
import Loadable from "react-loadable";
import Loading from "components/common/viewers/loading";
import { isPartnerSite } from "utils";

const Blogs = Loadable({
  loader: () => import("./blogs/Blogs"),
  loading: Loading,
});

const BlogDetail = Loadable({
  loader: () => import("./blogs/BlogDetail"),
  loading: Loading,
});

const Press = Loadable({
  loader: () => import("./press/Press"),
  loading: Loading,
});

const Home = Loadable({
  loader: () => (isPartnerSite() ? import("./home-page-whitelabel") : import("./home-page")),
  loading: Loading,
});

const ThankYou = Loadable({
  loader: () => import("./thank-you"),
  loading: Loading,
});

const HomeFarmer = Loadable({
  loader: () => import("./home-farmer"),
  loading: Loading,
});
const Landowner = Loadable({
  loader: () => import("./landowner"),
  loading: Loading,
});
const HowToLeaseFarmLand = Loadable({
  loader: () => import("./how-to-lease-farmland"),
  loading: Loading,
});
const ContactUs = Loadable({
  loader: () => import("./contact-us"),
  loading: Loading,
});

const AboutUs = Loadable({
  loader: () => import("./about-us/AboutUs"),
  loading: Loading,
});

const TermsAndConditions = Loadable({
  loader: () => import("./terms-and-conditions/TermsAndConditions"),
  loading: Loading,
});

const PrivatePolicy = Loadable({
  loader: () => import("./privacy-policy/PrivacyPolicy"),
  loading: Loading,
});

const SuccessAgreement = Loadable({
  loader: () => import("./my-account/sign-agreement-successful"),
  loading: Loading,
});

const RequestFreeEstimate = Loadable({
  loader: () => import("./free-estimate"),
  loading: Loading,
});

const EstimateOverview = Loadable({
  loader: () => import("./cashrent-estimate"),
  loading: Loading,
});
const FarmerSearchResult = Loadable({
  loader: () => import("./farmer-search-result"),
  loading: Loading,
});

const AlliancePartners = Loadable({
  loader: () => import("./alliance-partners"),
  loading: Loading,
});

const BiddingDetails = Loadable({
  loader: () => import("./my-account/bidding-details"),
  loading: Loading,
});

const LandDetail = Loadable({
  loader: () => import("./land-detail"),
  loading: Loading,
});

const Bidding = Loadable({
  loader: () => import("./bidding"),
  loading: Loading,
});

const SignLeaseContract = Loadable({
  loader: () => import("./sign-lease-contract/SignLeaseContract"),
  loading: Loading,
});

const AdminSearchListings = Loadable({
  loader: () => import("./admin/listing/SearchListingPage"),
  loading: Loading,
});

const AdminSiteManager = Loadable({
  loader: () => import("./admin/sites/Sites"),
  loading: Loading,
});

const AgreementsList = Loadable({
  loader: () => import("./admin/agreements/AdminAgreements"),
  loading: Loading,
});

const SearchEstimatePage = Loadable({
  loader: () => import("./admin/estimate/SearchEstimatePage"),
  loading: Loading,
});

const SearchUserPage = Loadable({
  loader: () => import("./admin/users/SearchUserPage"),
  loading: Loading,
});

const SearchBiddingPage = Loadable({
  loader: () => import("./admin/bidding/SearchBiddingPage"),
  loading: Loading,
});

const FindFarmForLease = Loadable({
  loader: () => import("./static-pages/find-farm-for-lease"),
  loading: Loading,
});

const FindFarmer = Loadable({
  loader: () => import("./static-pages/find-a-farmer"),
  loading: Loading,
});

const IllinoisFarmlandForRent = Loadable({
  loader: () => import("./static-pages/illinois-farmland-for-rent"),
  loading: Loading,
});

const IowaFarmlandForRent = Loadable({
  loader: () => import("./static-pages/iowa-farmland-for-rent"),
  loading: Loading,
});

const LazyFarmOverview = Loadable({
  loader: () => import("./farm-overview"),
  loading: Loading,
});

const LazyFarmCreate = Loadable({
  loader: () => import("./dashboard-farms-detail/FarmDetailsLayout"),
  loading: Loading,
});

const LazyFarmFields = Loadable({
  loader: () => import("./farm-fields"),
  loading: Loading,
});

const LazyFarmFieldDetail = Loadable({
  loader: () => import("./field-detail"),
  loading: Loading,
});

const LazyFarmEstimate = Loadable({
  loader: () => import("./farm-estimate"),
  loading: Loading,
});

const LazyFarmMaps = Loadable({
  loader: () => import("./farm-maps"),
  loading: Loading,
});

const LazyFarmLeases = Loadable({
  loader: () => import("./farm-leases"),
  loading: Loading,
});

const LazyDashboardFarms = Loadable({
  loader: () => import("./dashboard-farms/DashboardFarms"),
  loading: Loading,
});

const LazyDashboardListings = Loadable({
  loader: () => import("./dashboard-listings/DashboardListings"),
  loading: Loading,
});

const LazyDashboardLeases = Loadable({
  loader: () => import("./dashboard-leases/DashboardLeases"),
  loading: Loading,
});

const LazyDashboardSettings = Loadable({
  loader: () => import("./dashboard-settings/DashboardSettings"),
  loading: Loading,
});

const LazyDashboardPayments = Loadable({
  loader: () => import("./dashboard-payments/DashboardPayments"),
  loading: Loading,
});

const LazyDashboardMyBids = Loadable({
  loader: () => import("./dashboard-bids/DashboardBids"),
  loading: Loading,
});

const LazyListingCreate = Loadable({
  loader: () => import("./dashboard-listing-detail/CreateListing"),
  loading: Loading,
});

const LazyListingUpdate = Loadable({
  loader: () => import("./dashboard-listing-detail/UpdateListing"),
  loading: Loading,
});

const LazyTerms = Loadable({
  loader: () => import("./terms-conditions"),
  loading: Loading,
});

export default {
  [PAGE_CODES.HOME]: Home,
  [PAGE_CODES.FARMER]: HomeFarmer,
  [PAGE_CODES.FARMER_SEARCH_RESULT]: FarmerSearchResult,
  [PAGE_CODES.LANDOWNER]: Landowner,
  [PAGE_CODES.ALLIANCE_PARTNERS]: AlliancePartners,
  [PAGE_CODES.FREE_ESTIMATE]: RequestFreeEstimate,
  [PAGE_CODES.TERMS_AND_CONDITIONS]: TermsAndConditions,
  [PAGE_CODES.PRIVATE_POLICY]: PrivatePolicy,
  [PAGE_CODES.CASHRENT_ESTIMATE]: EstimateOverview,
  [PAGE_CODES.CONTACT_US]: ContactUs,
  [PAGE_CODES.ABOUT_US]: AboutUs,
  [PAGE_CODES.SUCCESS_AGREEMENT]: SuccessAgreement,
  [PAGE_CODES.BIDDING_DETAILS]: BiddingDetails,
  [PAGE_CODES.BIDDING_NEW]: Bidding,
  [PAGE_CODES.BIDDING_GUEST_SIGN]: SignLeaseContract,
  [PAGE_CODES.DASHBOARD_MY_BID]: LazyDashboardMyBids,
  [PAGE_CODES.BIDDING_GUEST_SIGN]: SignLeaseContract,
  [PAGE_CODES.LAND_DETAIL]: LandDetail,
  [PAGE_CODES.ADMIN_SEARCH_LISTING]: AdminSearchListings,
  [PAGE_CODES.ADMIN_ESTIMATE_PAGE]: SearchEstimatePage,
  [PAGE_CODES.ADMIN_USERS_PAGE]: SearchUserPage,
  [PAGE_CODES.ADMIN_BIDDING_PAGE]: SearchBiddingPage,
  [PAGE_CODES.ADMIN_AGREEMENTS]: AgreementsList,
  [PAGE_CODES.SITE_MANAGER]: AdminSiteManager,
  [PAGE_CODES.HOW_TO_LEASE_LANDFARM]: HowToLeaseFarmLand,
  [PAGE_CODES.THANK_YOU]: ThankYou,
  [PAGE_CODES.FIND_FARM_FOR_LEASE]: FindFarmForLease,
  [PAGE_CODES.FIND_A_FARMER]: FindFarmer,
  [PAGE_CODES.ILLINOIS_FARM_LAND_FOR_RENT]: IllinoisFarmlandForRent,
  [PAGE_CODES.IOWA_FARM_LAND_FOR_RENT]: IowaFarmlandForRent,
  [PAGE_CODES.FARM_CREATE]: LazyFarmCreate,
  [PAGE_CODES.FARM_OVERVIEW]: LazyFarmOverview,
  [PAGE_CODES.FARM_FIELDS]: LazyFarmFields,
  [PAGE_CODES.FARM_ESTIMATE]: LazyFarmEstimate,
  [PAGE_CODES.FARM_MAPS]: LazyFarmMaps,
  [PAGE_CODES.FARM_LEASES]: LazyFarmLeases,
  [PAGE_CODES.FIELD_DETAIL]: LazyFarmFieldDetail,
  [PAGE_CODES.LISTING_CREATE]: LazyListingCreate,
  [PAGE_CODES.LISTING_UPDATE]: LazyListingUpdate,
  [PAGE_CODES.LAND_TERMS]: LazyTerms,
  // dashboard screens
  [PAGE_CODES.DASHBOARD_FARMS]: LazyDashboardFarms,
  [PAGE_CODES.DASHBOARD_LISTINGS]: LazyDashboardListings,
  [PAGE_CODES.DASHBOARD_LEASES]: LazyDashboardLeases,
  [PAGE_CODES.DASHBOARD_SETTINGS]: LazyDashboardSettings,
  [PAGE_CODES.DASHBOARD_PAYMENTS]: LazyDashboardPayments,
  [PAGE_CODES.BLOGS]: Blogs,
  [PAGE_CODES.BLOG_DETAIL]: BlogDetail,
  [PAGE_CODES.PRESS]: Press,
};
